import Nav from "@/components/vu/Nav";
import Footer from "@/components/vu/Footer";

const Section = ({ title, children }) => (
    <div className="mb-9">
        <h2 className="font-display text-[22px] text-[#F5F0E8] mb-3">{title}</h2>
        <div className="text-[15px] leading-[1.75] text-[#A6BDB0] space-y-3">{children}</div>
    </div>
);

export default function TermsOfService() {
    return (
        <main data-testid="terms-page" className="bg-[#0E1F16] min-h-screen">
            <Nav />
            <div className="max-w-[820px] mx-auto px-8 pt-40 pb-24">
                <h1 className="font-display text-[2.4rem] text-[#F5F0E8] mb-2">Terms of Service</h1>
                <p className="text-[13px] text-[#7A9088] mb-12">Last updated: [DATE]</p>

                <Section title="1. Agreement to terms">
                    <p>By submitting a form, purchasing a plan, or otherwise using vusolutions-dev.com (the "Site") or our services, you agree to these Terms of Service. If you do not agree, do not use the Site or our services.</p>
                </Section>

                <Section title="2. Our services">
                    <p>VU Solutions ("we," "us") provides website design and development, Google Business Profile and local SEO, Google and Meta advertising management, email and SMS marketing, and an AI voice agent phone system (in partnership with Orbit Force AI), delivered under one of our published retainer plans (Foundation, Growth, or Elite + AI) or a custom scope agreed separately.</p>
                </Section>

                <Section title="3. Fees and billing">
                    <ul className="list-disc pl-5 space-y-1">
                        <li>Plans require an upfront setup fee, charged at signup via Stripe.</li>
                        <li>Growth and Elite + AI plans include a recurring monthly fee, billed automatically to your payment method on file each billing cycle.</li>
                        <li>Advertising spend (Google/Meta ad budgets) is billed separately from our monthly fee and is passed through at the amount you authorize.</li>
                        <li>You are responsible for keeping your payment method current. Failed payments may result in paused services.</li>
                    </ul>
                </Section>

                <Section title="4. Cancellation">
                    <p>Monthly retainer plans are month-to-month with no long-term lock-in. You may cancel at any time with 30 days' written notice to [BILLING CONTACT EMAIL]. Service continues, and billing continues, through the end of the current notice period.</p>
                </Section>

                <Section title="5. Refunds">
                    <p>Setup fees are non-refundable once work has begun. Monthly fees are non-refundable for periods in which service has already been rendered. If you believe you were billed in error, contact us at [BILLING CONTACT EMAIL] and we'll review it in good faith. <span className="text-[#F5F0E8]">[PLACEHOLDER — confirm your actual refund policy here before publishing.]</span></p>
                </Section>

                <Section title="6. No guarantee of results">
                    <p>Digital marketing outcomes (rankings, ad performance, lead volume, ROAS) depend on many factors outside our control, including market conditions, competition, and platform algorithm changes. We do not guarantee specific results, rankings, or revenue outcomes. Any statistics referenced on this Site (e.g. average client results) are historical averages, not guarantees for your business.</p>
                </Section>

                <Section title="7. AI voice agent & consent to be contacted">
                    <p>If you submit an inquiry through our Site, you consent to being contacted by phone, SMS, or email regarding your inquiry, including by an AI voice agent operated by our partner Orbit Force AI. Calls may be recorded and transcribed for quality assurance and follow-up purposes. You may opt out of further contact at any time by informing us directly.</p>
                </Section>

                <Section title="8. User-submitted content (reviews)">
                    <p>By submitting a review on our Site, you grant us a non-exclusive, royalty-free, worldwide license to display, reproduce, and use that review (including your name and stated role) on our Site and in our marketing materials. You confirm the review reflects your genuine experience. We reserve the right to remove any review at our discretion, including reviews that are false, abusive, or spam.</p>
                </Section>

                <Section title="9. Intellectual property">
                    <p>Deliverables created for you under an active plan (e.g. your website, ad creative) become your property upon full payment, unless otherwise agreed in writing. We retain ownership of our own pre-existing tools, templates, and methodologies used to deliver services.</p>
                </Section>

                <Section title="10. Limitation of liability">
                    <p>To the fullest extent permitted by law, VU Solutions will not be liable for indirect, incidental, or consequential damages arising from your use of our services or this Site. Our total liability for any claim will not exceed the amount you paid us in the three months preceding the claim.</p>
                </Section>

                <Section title="11. Governing law">
                    <p>These terms are governed by the laws of [STATE], without regard to conflict-of-law principles. <span className="text-[#F5F0E8]">[PLACEHOLDER — fill in your state/jurisdiction.]</span></p>
                </Section>

                <Section title="12. Changes to these terms">
                    <p>We may update these terms from time to time. Continued use of the Site or our services after changes take effect constitutes acceptance of the updated terms.</p>
                </Section>

                <Section title="13. Contact us">
                    <p>Questions about these terms? Email us at [BILLING CONTACT EMAIL].</p>
                </Section>
            </div>
            <Footer />
        </main>
    );
}